/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ChangeItemContent.less';
import ChangeItemContentItem, {
  CHANGE_TYPE,
  getChangeType,
  splitByChangeTypes,
} from './ChangeItemContentItem';
import {KEYWORD_PROP_CONTENT_VALUE} from 'src/js/model/auto_layout_screen_data_helpers';

const CHANGE_FIELDS = 'fields';

function sortByChangeType(data) {
  return data?.sort((first, second) => {
    let result = 0;
    const firstChangeType = getChangeType(first);
    const secondChangeType = getChangeType(second);
    if (firstChangeType < secondChangeType) {
      result = 1;
    } else if (firstChangeType > secondChangeType) {
      result = -1;
    }
    return result;
  });
}

const ChangeItemContent = ({data}) => {
  const itemData = data[KEYWORD_PROP_CONTENT_VALUE];
  let changedFieldsSplit = [];
  if (itemData && itemData[CHANGE_FIELDS]) {
    itemData[CHANGE_FIELDS].forEach((item) => {
      changedFieldsSplit = changedFieldsSplit.concat(splitByChangeTypes(item));
    });
  }
  const changedFields = sortByChangeType(
    changedFieldsSplit?.map((item) => ({
      ...item,
      [CHANGE_TYPE]: getChangeType(item),
    }))
  );
  return (
    <div className={styles.dlChangeItemContent}>
      {changedFields &&
        changedFields.length > 0 &&
        changedFields.map((item, idx) => {
          const isLast = idx === changedFields.length - 1;
          const showActionLabel =
            idx === 0 ||
            (changedFields[idx - 1] &&
              item &&
              changedFields[idx - 1][CHANGE_TYPE] !== item[CHANGE_TYPE]);
          return (
            <ChangeItemContentItem
              item={item}
              isLast={isLast}
              key={idx}
              showActionLabel={showActionLabel}
            />
          );
        })}
    </div>
  );
};

ChangeItemContent.displayName = 'ChangeItemContent';

/* eslint-disable react/no-unused-prop-types */
ChangeItemContent.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
};

ChangeItemContent.defaultProps = {
  data: {},
};

export default ChangeItemContent;
